import React from 'react'

interface LoadingSpinnerProps {
    size?: 'small' | 'medium' | 'large'
    className?: string
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
    size = 'medium',
    className = ''
}) => {
    const sizeClasses = {
        small: 'loader-sm',
        medium: 'loader-md',
        large: 'loader-lg'
    }

    return (
        <div
            className={`loader ${sizeClasses[size]} ${className}`}
        />
    )
}

interface LoadingProps {
    message?: string
    size?: 'small' | 'medium' | 'large'
    className?: string
}

const Loading: React.FC<LoadingProps> = ({
    message = 'Loading...',
    size = 'medium',
    className = ''
}) => {
    return (
        <div className={`flex items-center justify-center space-x-3 ${className}`}>
            <LoadingSpinner size={size} className="text-brand-600" />
            {message && (
                <span className="text-lg text-gray-600 font-medium" style={{ fontFamily: 'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif' }}>
                    {message}
                </span>
            )}
        </div>
    )
}

export default Loading
export { LoadingSpinner }